module.exports = __webpack_public_path__ + "static/media/rc.43be809d.png";